'use strict';

function shouldExclude(reqConfig, config) {
  return reqConfig.url.indexOf(config.apiBase) !== 0 &&
         reqConfig.url.indexOf(config.formApiBase) !== 0 ||
         reqConfig.method === 'POST' && (
           reqConfig.url === config.apiBase + '/tokens' ||
           reqConfig.url === config.apiBase + '/users/forgot-password' ||
           reqConfig.url === config.apiBase + '/users' ||
           reqConfig.url === config.apiBase + '/authorize?appId=' + config.appId
         ) || (reqConfig.url.indexOf(config.apiBase + '/users/') === 0 && reqConfig.url.indexOf('reset-password?code=') > -1);
}

var noTokenSet = {
  data:   {
    error: {
      message: "No token has been set"
    }
  },
  status: 401
};

function AuthInterceptor($window, $q, config) {
  return {
    request: function(reqConfig) {
      if(shouldExclude(reqConfig, config)) {
        return reqConfig;
      }

      if(!$window.localStorage.token) {
        return $q.reject(noTokenSet);
      }

      reqConfig.headers               = reqConfig.headers || {};
      reqConfig.headers.Authorization = 'Bearer ' + $window.localStorage.token;
      reqConfig.headers['Accept-Language'] = $window.localStorage.language || 'se';

      return reqConfig;
    }
  };
}

function registerAuthInterceptor($httpProvider) {
  $httpProvider.interceptors.push('AuthInterceptor');
}

angular.module('dokiv')
  .factory('AuthInterceptor', ['$window', '$q', 'config', AuthInterceptor])
  .config(['$httpProvider', registerAuthInterceptor]);



//////////////////
// WEBPACK FOOTER
// ./scripts/auth/AuthInterceptor.js
// module id = 275
// module chunks = 0